import { AlertIcon, OkOIcon, TOOLTIP_POSITION, TooltipV2 as Tooltip } from 'taboola-ultimate-ui';
import styles from './userMatchingRow.module.scss';

export const UserMatchingRow = ({ children, indicator, tooltipContent }) => {
    const tooltipProps = {
        interactive: true,
        placement: indicator ? TOOLTIP_POSITION.RIGHT : TOOLTIP_POSITION.RIGHT_START,
    };

    return (
        <div className={styles['user-matching-row']}>
            {indicator ? (
                <OkOIcon className={styles['ok-icon']} aria-label="ok-icon" role="img" />
            ) : (
                <AlertIcon className={styles['error-icon']} aria-label="error-icon" role="img" />
            )}
            {children}
            {tooltipContent && (
                <Tooltip arrow {...tooltipProps}>
                    {tooltipContent}
                </Tooltip>
            )}
        </div>
    );
};
